// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__-xJhX","productName":"Table_productName__3VM8-"};